import { ERROR_DICTIONARY, ERRORS } from '../../utils/errorDictionary';

const COMMENT_LENGTH_MIN = 2;
const COMMENT_LENGTH_MAX = 4000;

export const validateComment = (text: string): { error: boolean; errorMessage: string } => {
  let validationState = {
    error: false,
    errorMessage: '',
  };

  const hasRepeatedChars = text.toLowerCase().match(/([^a-zа-я0-9])\1{3,}/g);

  if (text.length < COMMENT_LENGTH_MIN) {
    validationState.errorMessage = 'Слишком короткий текст';
  }

  if (text.length > COMMENT_LENGTH_MAX) {
    validationState.errorMessage = 'Слишком длинный текст';
  }

  if (hasRepeatedChars) {
    validationState.errorMessage = ERROR_DICTIONARY[ERRORS.REPEATING_CHARS];
  }

  if (validationState.errorMessage) {
    validationState.error = true;
  }

  return validationState;
};

export const removeCommentCompany = (arr: number[], companyId: number): number[] => {
  const index = arr.indexOf(companyId);
  if (index !== -1) {
    arr.splice(index, 1);
  }
  return arr;
};

export const getCommentCompany = (arr: number[], companyId: number): number[] => {
  return arr.filter((id) => id === companyId);
};
